export default __webpack_public_path__ + "static/media/Dolphins.4b453322.jpg";